import type { Transition } from "@spz/shared-domain";

interface WorkflowPermissions {
  canStartInvestigationAndReinclude: boolean;
  canSkipResult: boolean;
  canCompleteInvestigation: boolean;
}

export function filterWorkflowTransitions(
  transitions: Transition[] | null,
  permissions: WorkflowPermissions,
): Transition[] {
  if (!transitions) return [];

  return transitions.filter((transition) => {
    const key = transition?.trigger?.label_key;

    switch (key) {
      case "workflow_transition_not_started_to_in_progress":
        return !!permissions.canStartInvestigationAndReinclude;
      case "workflow_transition_skipped_to_not_started":
        return !!permissions.canStartInvestigationAndReinclude;
      case "workflow_investigation_completion_button":
      case "workflow_transition_completed_to_not_started":
        return !!permissions.canCompleteInvestigation;
      case "workflow_investigation_skip_button":
        return !!permissions.canSkipResult;
      default:
        return false;
    }
  });
}
